// removed by extract-text-webpack-plugin
module.exports = {"container":"_2CKCa0c","menuItem":"_2ZrmXYA","label":"jsC7K1m","label__light":"_3uQ41qA","label__sale":"_1dvZaW2","subtitle":"_3XTwJYe","flatMenuItem":"_2rvxCv1"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/FlatItem/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/FlatItem/index.css
// module chunks = client.sitechrome